import { render, staticRenderFns } from "./IconAppartement.vue?vue&type=template&id=2ef68a4c"
import script from "./IconAppartement.vue?vue&type=script&lang=ts"
export * from "./IconAppartement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports